import styled from 'styled-components';
import NextLink from 'next/link';
import { ButtonLink } from 'components/Toolkit/Button/ButtonLink';
import { WhitePanel } from 'components/Toolkit/WhitePanel/WhitePanel';
import { media } from 'helpers/breakpoints';

export const SWhitePanel = styled(WhitePanel)`
  display: flex;
  flex-direction: column;
  max-width: 100%;
  gap: ${({ theme }) => theme.spacing.M16};
  padding: ${({ theme }) => theme.spacing.M24};

  ${media.large} {
    flex-direction: row;
    justify-content: space-between;
    gap: ${({ theme }) => theme.spacing.M24};
  }
`;
export const IconAndTextContainer = styled.div`
  flex: 70%;
`;

export const SButtonLink = styled(ButtonLink)`
  flex: 30%;
  align-items: center;
  width: 100%;
  margin-top: auto;
  ${media.large} {
    width: 200px;
  }
`;

export const Header = styled.p`
  ${({ theme }) => theme.fontSize.M16};
  color: ${({ theme }) => theme.colors.GREY_DARKER};
  font-weight: ${({ theme }) => theme.fontWeight.bold};

  ${media.large} {
    ${({ theme }) => theme.fontSize.L18};
  }
`;

export const Subtitle = styled.p`
  ${({ theme }) => theme.fontSize.B12};

  ${media.large} {
    ${({ theme }) => theme.fontSize.M14};
    display: block;
  }
`;

export interface IElectricCarsHubPanel {
  className?: string;
}

function ElectricCarsHubPanel({ className }: IElectricCarsHubPanel) {
  return (
    <SWhitePanel className={className}>
      <IconAndTextContainer>
        <div>
          <Header>Thinking of buying an Electric Car?</Header>
          <Subtitle>
            Curious about electric car running costs, grants, range or charging
            times? All of these questions, and more, answered on our Electric
            Car Hub.
          </Subtitle>
        </div>
      </IconAndTextContainer>
      <SButtonLink ofType="SECONDARY" NextLink={NextLink} href="/electric-cars">
        Visit Electric Car Hub
      </SButtonLink>
    </SWhitePanel>
  );
}

export { ElectricCarsHubPanel };
